import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { useBackgroundImageWithFallback } from '../../../hooks/useBackgroundImageWithFallback';
import * as ListingUtils from '../utils';
import SimpleMap from '../../layouts/simpleMap';
import styles from './index.scss';
const cx = classnames.bind(styles);
export const LISTING_INFORMATION_PHOTO_WIDTH = 955;
export const TABS = {
    NONE: null,
    PHOTOS: 0,
    MAP: 1,
    STREET: 2,
};
export const VerifiedImage = ({ url, featureFlags, defaultPhotoConfigKey, ...restProps }) => {
    const { formatListingImgUrl } = ListingUtils.ListingFormatters;
    const mainImage = useBackgroundImageWithFallback(url, featureFlags['fe.resi.enabled-photo-enhancement'], undefined, undefined, defaultPhotoConfigKey);
    return (_jsx("img", { src: formatListingImgUrl(`${mainImage}`, {
            width: LISTING_INFORMATION_PHOTO_WIDTH,
        }), ...restProps }));
};
export const BackgroundImage = ({ url, featureFlags, className, defaultPhotoConfigKey, ...restProps }) => {
    const mainImage = useBackgroundImageWithFallback(url, featureFlags['fe.resi.enabled-photo-enhancement'], undefined, undefined, defaultPhotoConfigKey);
    return (_jsx("div", { className: cx('background-image', className), style: { backgroundImage: `url(${mainImage})` }, ...restProps }));
};
export const SecondaryItem = ({ index, renderer, className, }) => (_jsx("div", { className: cx('secondary-photo', `index-${index}`, 'priority', className), children: renderer() }, index));
export const MapItem = ({ defaultView, index, coords, setActiveTab, showStreetView = false, }) => (_jsx(SecondaryItem, { index: index, renderer: () => (_jsx(SimpleMap, { defaultView: defaultView, coords: coords, createMapOptions: () => ({
            mapTypeControl: false,
        }), onMapClick: () => {
            setActiveTab(showStreetView ? TABS.STREET : TABS.MAP);
        }, showStreetView: showStreetView })) }));
//# sourceMappingURL=parts.js.map